import { render, staticRenderFns } from "./arrow-key-focuser.vue?vue&type=template&id=39601dee"
import script from "./arrow-key-focuser.vue?vue&type=script&lang=js"
export * from "./arrow-key-focuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports